import { z } from 'zod'

export const accountChangePasswordSchema = z.object({
   oldPassword: z.string().min(6, 'Please enter a old password of at least 6 characters'),
   newPassword: z.string().min(6, 'Please enter a new password of at least 6 characters').regex(new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$"),"Password must be contains at least one uppercase letter, one lowercase letter, one number and one special character"),
   confirmPassword: z.string().min(6, 'Please enter a confirm password of at least 6 characters'),
})

export type AccountChangePasswordInput = z.TypeOf<typeof accountChangePasswordSchema>
